import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import { useOnClickOutside, useWindowWidth } from '../../utils';
import MoreActions from '../icons/MoreActions';
import editImg from '../../assets/images/edit.svg';
import deleteImg from '../../assets/images/delete.svg';

const types = [
  { label: 'Funding', value: 'Funding' },
  { label: 'Data', value: 'Data' },
  { label: 'Influence', value: 'Influence' },
];

const ConnectionCell = ({
  connection,
  index,
  stakeholders,
  setSelected,
  setShowEditConnectionModal,
  setShowDeleteConnectionModal,
}) => {
  const width = useWindowWidth();
  const ref = useRef();
  const exceptional = useRef();
  const [showActions, setShowActions] = useState(false);

  useOnClickOutside(ref, () => setShowActions(false), exceptional);

  const handlShowEditModal = () => {
    setSelected({
      ...connection,
      type: types.find((t) => t.label === connection.type),
      from: stakeholders.find((s) => s.id === connection.from.id),
      to: stakeholders.find((s) => s.id === connection.to.id),
    });
    setShowActions(false);
    setShowEditConnectionModal(true);
  };

  const handleShowDeleteModal = () => {
    setSelected(connection);
    setShowActions(false);
    setShowDeleteConnectionModal(true);
  };

  return (
    <>
      {width > 600 ? (
        <div className="connection-item" key={connection.id}>
          <div className="item-id">#{index}</div>
          <div className="item-type">
            <span
              className={classNames('inner-type', {
                funding: connection.type === 'Funding',
                data: connection.type === 'Data',
                influence: connection.type === 'Influence',
              })}
            >
              {connection.type}
            </span>
          </div>
          <div className="item-from">{connection.from ? connection.from.name : ''}</div>
          <div className="item-to">{connection.to ? connection.to.name : ''}</div>
          <div className="item-notes">{connection.notes}</div>
          <div
            className="more-actions"
            onClick={() => setShowActions(!showActions)}
            ref={exceptional}
          >
            <MoreActions color={showActions ? '#01244E' : '#B8C0CC'} />
          </div>
          {showActions && (
            <div className="actions" ref={ref}>
              <div className="action-item" onClick={() => handlShowEditModal()}>
                <img src={editImg} alt="edit" />
                <span>Edit Connection</span>
              </div>
              <div className="action-item" onClick={() => handleShowDeleteModal()}>
                <img src={deleteImg} alt="delete" />
                <span>Delete Connection</span>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="mobile-connection-item">
          <div className="mobile-connection-item-cell">
            <div className="mobile-connection-item-cell-title">Type</div>
            <div className="mobile-connection-item-cell-content">
              <span
                className={classNames('inner-type', {
                  funding: connection.type === 'Funding',
                  data: connection.type === 'Data',
                  influence: connection.type === 'Influence',
                })}
              >
                {connection.type}
              </span>
            </div>
            <div
              className="more-actions"
              onClick={() => setShowActions(!showActions)}
              ref={exceptional}
            >
              <MoreActions color={showActions ? '#01244E' : '#B8C0CC'} />
            </div>
          </div>
          <div className="mobile-connection-item-cell">
            <div className="mobile-connection-item-cell-title">From</div>
            <div className="mobile-connection-item-cell-content">
              {connection.from ? connection.from.name : ''}
            </div>
          </div>
          <div className="mobile-connection-item-cell">
            <div className="mobile-connection-item-cell-title">To</div>
            <div className="mobile-connection-item-cell-content">
              {connection.to ? connection.to.name : ''}
            </div>
          </div>
          <div className="mobile-connection-item-cell">
            <div className="mobile-connection-item-cell-title">Notes</div>
            <div className="mobile-connection-item-cell-content connection-notes">
              {connection.notes}
            </div>
          </div>
          {showActions && (
            <div className="actions" ref={ref}>
              <div className="action-item" onClick={() => handlShowEditModal()}>
                <img src={editImg} alt="edit" />
                <span>Edit Connection</span>
              </div>
              <div className="action-item" onClick={() => handleShowDeleteModal()}>
                <img src={deleteImg} alt="delete" />
                <span>Delete Connection</span>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ConnectionCell;
